module.exports = __webpack_public_path__ + "assets/img/picture9.b0e46275.svg";